<script type="text/javascript">

    import { Line } from 'vue-chartjs'
    import colors from './chart-colors.const'

    export default {
        extends : Line,
        name: 'chart-line',
        props : {
            title : {
                type : String,
                default : ''
            },
            collection : {
                type : Array,
                default : () => []
            },
            color : {
                type : String,
                default : 'blue'
            },
            showDots : {
                type : Boolean,
                default : false
            },
            collectionLabel : {
                type : String,
                default : 'key'
            },
            collectionValue : {
                type : String,
                default : 'value'
            }
        },
        components: {
            
        },
        data () {
            return {
                
            }
        },
        computed : {
            lineColor ()  {
                return colors[this.color.toUpperCase()].main;
            },
            fillColor () {
                return colors[this.color.toUpperCase()].light;
            }
        },
        mounted () {
            this.makeChart();
        },
        created () {

        },
        methods : {
            makeChart () {
                let labels = [];
                let dataset = [];

                for (let i in this.collection) {
                    labels.push(this.collection[i][this.collectionLabel]);
                    dataset.push(this.collection[i][this.collectionValue]);
                }

                this.renderChart({
                         labels: labels,
                         datasets: [
                            {
                                label: this.title,
                                borderColor : this.lineColor,
                                borderWidth : this.showDots ? 2 : 4,
                                backgroundColor: this.fillColor,
                                pointBackgroundColor : this.lineColor,
                                pointBorderColor : this.showDots ? '#ffffff' : '#ffffff00',
                                pointBorderWidth : this.showDots ? 4 : 0,
                                pointRadius : this.showDots ? 6 : 0,
                                pointZ:2,
                                data: dataset
                            }
                        ]
                    },
                    {
                        responsive: true,
                        maintainAspectRatio: false,
                        height : 200,
                        legend: {
                            display: false
                        },
                        tooltips : {
                            enabled : true
                        },
                        elements :{
                            line : {
                                tension : 0.8,
                                cubicInterpolationMode : 'monotone'
                            }
                        },
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    color: "rgba(0, 0, 0, 0)",
                                    zeroLineColor: 'rgba(255,255,255,1)',
                                    lineWidth : 5,
                                    zeroLineWidth : 2,
                                    z:1
                                },
                                ticks : {
                                    fontColor : '#777777',
                                    fontFamily : 'Didact Gothic'
                                }
                            }],
                            yAxes: [{
                                gridLines: {
                                    zeroLineColor : 'rgba(255,255,255,1)',
                                    color: "#eeeeee",
                                    lineWidth : 2
                                },
                                ticks: {
                                    beginAtZero: true,
                                    fontColor : '#777777',
                                    fontFamily : 'Didact Gothic',
                                    padding: 35,
                                    callback: (value) => {
                                        return value;
                                    }
                                }
                            }]
                        }
                    }
                );
            }
        },
        watch : {
            collection () {
                console.log("REMAKE")
                this.makeChart();
            }
        }
  }

</script>